import { jsx as i, jsxs as n } from "react/jsx-runtime";
import * as l from "react";
import * as t from "@radix-ui/react-dialog";
import { X as p } from "lucide-react";
import { cn as o } from "../../../lib/utils.js";
import { motion as m } from "framer-motion";
const C = t.Root, R = t.Trigger, T = t.Close, f = t.Portal, c = l.forwardRef(({ className: e, ...a }, r) => i(t.Overlay, { ref: r, asChild: !0, ...a, children: i(m.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, className: o("fixed inset-0 z-50 bg-lpr-teal/10 dark:bg-lpr-charcoal/60 backdrop-blur-xl", e) }) }));
c.displayName = t.Overlay.displayName;
const y = l.forwardRef(({ side: e = "right", className: a, children: r, ...d }, x) => {
  const s = {
    right: { initial: { x: "100%" }, animate: { x: 0 }, exit: { x: "100%" } },
    left: { initial: { x: "-100%" }, animate: { x: 0 }, exit: { x: "-100%" } },
    top: { initial: { y: "-100%" }, animate: { y: 0 }, exit: { y: "-100%" } },
    bottom: { initial: { y: "100%" }, animate: { y: 0 }, exit: { y: "100%" } }
  }[e];
  return n(f, { children: [i(c, {}), i(t.Content, { ref: x, asChild: !0, ...d, children: n(m.div, { initial: s.initial, animate: s.animate, exit: s.exit, transition: { type: "spring", stiffness: 300, damping: 35, mass: 0.8 }, className: o("fixed z-50 gap-4 bg-surface border border-border-color p-8 shadow-luxury", e === "top" && "inset-x-0 top-0 rounded-b-3xl", e === "bottom" && "inset-x-0 bottom-0 rounded-t-3xl", e === "left" && "inset-y-0 left-0 h-full w-3/4 sm:max-w-sm rounded-r-3xl", e === "right" && "inset-y-0 right-0 h-full w-3/4 sm:max-w-sm rounded-l-3xl", a), children: [r, n(t.Close, { className: "absolute right-6 top-6 rounded-full p-1 opacity-20 transition-all hover:opacity-100 hover:bg-border-color active:scale-90", children: [i(p, { className: "h-5 w-5 text-text-primary" }), i("span", { className: "sr-only", children: "Close" })] })] }) })] });
});
y.displayName = t.Content.displayName;
const h = ({ className: e, ...a }) => i("div", { className: o("flex flex-col space-y-2 text-center sm:text-left", e), ...a });
h.displayName = "SheetHeader";
const N = ({ className: e, ...a }) => i("div", { className: o("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e), ...a });
N.displayName = "SheetFooter";
const g = l.forwardRef(({ className: e, ...a }, r) => i(t.Title, { ref: r, className: o("text-lg font-semibold text-text-primary", e), ...a }));
g.displayName = t.Title.displayName;
const u = l.forwardRef(({ className: e, ...a }, r) => i(t.Description, { ref: r, className: o("text-sm text-text-secondary", e), ...a }));
u.displayName = t.Description.displayName;
export {
  C as Sheet,
  T as SheetClose,
  y as SheetContent,
  u as SheetDescription,
  N as SheetFooter,
  h as SheetHeader,
  c as SheetOverlay,
  f as SheetPortal,
  g as SheetTitle,
  R as SheetTrigger
};
//# sourceMappingURL=Sheet.js.map
